import dayjs from "dayjs";

import { formatNumber } from "helpers/formatNumber";
import { IWalletHistoryItem } from "models/HaulPay";
import styles from "./style.module.scss";

interface IProps {
  data: IWalletHistoryItem;
}

export default function BrokerWalletHistoryItem({ data }: Readonly<IProps>) {
  const { created, description, invoice_number, credit_amount, debit_amount, wallet_balance } =
    data;
  const createdDate = dayjs(created).format("MM/DD/YYYY");

  return (
    <div className="pb-4.5">
      <ul className={styles.walletHistoryItemContainer}>
        <li>
          <span className="font-bold">Date</span>
          <span>{createdDate}</span>
        </li>
        <li>
          <span className="font-bold">Description</span>
          <span>{description}</span>
        </li>
        <li>
          <span className="font-bold">Invoice</span>
          <span>{invoice_number}</span>
        </li>
        <li>
          <span className="font-bold">Credit</span>
          <span>{formatNumber(credit_amount, 2)}</span>
        </li>
        <li>
          <span>Debit</span>
          <span>{formatNumber(debit_amount, 2)}</span>
        </li>
      </ul>
      <div className={styles.result}>
        <span>Balance</span>
        <span>{formatNumber(wallet_balance, 2)}</span>
      </div>
    </div>
  );
}
